import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import HangoutNapsterEmbed, {
  HangoutPublicAPI,
} from './components/HangoutNapsterEmbed';

const OldMusicsPage: React.FC = () => {
  const hangoutRef = useRef<HangoutPublicAPI>(null);
  const { user } = useAuth();

  // Get the user token from auth context
  const userToken = user?.access_token || '';

  useEffect(() => {
    // You can use hangoutRef.current to call methods like:
    // hangoutRef.current?.playTrack('trackId');
    // hangoutRef.current?.playPlaylist('playlistId');
    // hangoutRef.current?.joinRoom('roomName');
  }, []);

  return (
    <div className="w-full h-full flex flex-col top-10">
      <HangoutNapsterEmbed
        ref={hangoutRef}
        env="staging"
        userToken={userToken}
        className="w-full"
      />
    </div>
  );
};

export default OldMusicsPage;
